import React, { useEffect, useState } from 'react';
import api from '../../../../api';
import './Approval.css';
import DynamicBanner from '../include/DynamicBanner';

/**
 * DocCard Component
 */
const DocCard = ({ year, docs, id, colorIndex }) => {
  const colorClass =
    colorIndex % 2 === 0 ? 'bg-primary-dark' : 'bg-primary-light';

  return (
    <div className="col-lg-3 col-md-6">
      <div className="doc-card-approval">
        {/* Accordion Header */}
        <div
          className={`card-header-custom ${colorClass}`}
          data-bs-toggle="collapse"
          data-bs-target={`#${id}`}
          data-bs-parent="#yearAccordion"
          aria-expanded="false"
          aria-controls={id}
        >
          <span className="truncate-text-approval">{year}</span>
          <i className="fa fa-chevron-down arrow-icon"></i>
        </div>

        {/* Accordion Body */}
        <div id={id} className="collapse" data-bs-parent="#yearAccordion">
          <div className="card-body-custom">
            {docs.map((doc, index) => (
              <a
                href={
                  doc.url.startsWith('http')
                    ? doc.url
                    : `${process.env.REACT_APP_API_URL}/public${doc.url}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className="doc-link-approval"
                key={index}
              >
                <span className="doc-link-approval-text">{doc.title}</span>
                <i className="fa fa-file-pdf-o external-icon"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Main Approval Component
 */
function Approval() {
  const [bannerData, setBannerData] = useState(null);
  const [contentData, setContentData] = useState({});

  useEffect(() => {
    api
      .get('/api/sitepages/about-approval')
      .then((res) => {
        if (res.data.banner_data) setBannerData(res.data.banner_data);

        const approvalGroup = res.data.groups?.find((g) => g.approvalCategories);
        const transformedData = {};

        if (approvalGroup && approvalGroup.approvalCategories) {
          const approvalCategories =
            approvalGroup.approvalCategories.approvalCategories;

          approvalCategories.forEach((cat) => {
            // Create section
            transformedData[cat.categoryName] = {
              title: cat.categoryName,
              years: [],
            };

            // Sort years by 'order'
            const sortedYears = [...cat.years].sort(
              (a, b) => Number(a.order) - Number(b.order)
            );

            // Store as an array (NOT object)
            sortedYears.forEach((yr) => {
              transformedData[cat.categoryName].years.push({
                year: yr.year,
                order: Number(yr.order),
                documents: (yr.documents || []).map((doc) => ({
                  title: doc.title || doc.displayName || 'Untitled',
                  url: doc.url,
                  displayName: doc.displayName,
                })),
              });
            });
          });
        }

        setContentData(transformedData);
      })
      .catch((err) => console.log(err));
  }, []);

  // Accordion animation logic
  useEffect(() => {
    const collapseElements = document.querySelectorAll(
      '#yearAccordion .collapse'
    );

    const handleShow = function () {
      const header = document.querySelector(`[data-bs-target="#${this.id}"]`);
      if (header) {
        header.querySelector('.arrow-icon')?.classList.add('rotated');
        const title = header.querySelector('span');
        title?.classList.remove('truncate-text-approval');
        title?.classList.add('expanded-text');
      }
    };

    const handleHide = function () {
      const header = document.querySelector(`[data-bs-target="#${this.id}"]`);
      if (header) {
        header.querySelector('.arrow-icon')?.classList.remove('rotated');
        const title = header.querySelector('span');
        title?.classList.add('truncate-text-approval');
        title?.classList.remove('expanded-text');
      }
    };

    collapseElements.forEach((el) => {
      el.addEventListener('shown.bs.collapse', handleShow);
      el.addEventListener('hidden.bs.collapse', handleHide);
    });

    return () => {
      collapseElements.forEach((el) => {
        el.removeEventListener('shown.bs.collapse', handleShow);
        el.removeEventListener('hidden.bs.collapse', handleHide);
      });
    };
  }, [contentData]);

  if (Object.keys(contentData).length === 0) return null;

  return (
    <>
      {bannerData && (
        <DynamicBanner
          images={bannerData.images}
          buttons={bannerData.buttons}
          heading={bannerData.heading}
        />
      )}

      <section className="pb_80">
        <div className="container">
          <section className="mb-5 mt-3 mt-md-0">
            <div className="row g-4 accordion" id="yearAccordion">
              {Object.values(contentData).map((section) => (
                <React.Fragment key={section.title}>
                  <div className="col-12">
                    <div className="sec-title text-center">
                      <h2>{section.title}</h2>
                    </div>
                  </div>

                  {/* Render years in correct order */}
                  {section.years.map((yr, index) => {
                    const uniqueId = `acc_${section.title.replace(/[^a-zA-Z0-9]/g, '')}_${index}`;

                    return (
                      <DocCard
                        key={uniqueId}
                        id={uniqueId}
                        year={yr.year}
                        docs={yr.documents}
                        colorIndex={index}
                      />
                    );
                  })}
                </React.Fragment>
              ))}
            </div>
          </section>
        </div>
      </section>
    </>
  );
}

export default Approval;
